import { EnrollmentInvestmentExperienceCategory } from '@egw/api/src/models/enrollment/enrollment'
import { Button, Field, ModalDrawer, RadioGroup, useModalState } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { FC, useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

// Compononent to Be used within a FormProvider from react-hook-form
export const EditInvestmentExperience: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const { openModal, closeModal, isOpen } = useModalState()

  const [defaultInvestmentExperience, setDefaultInvestmentExperience] = useState<
    EnrollmentInvestmentExperienceCategory | undefined
  >(undefined)

  const { control, watch, setValue } = useFormContext()

  const experience = watch('experience')

  useEffect(() => {
    if (experience !== undefined && defaultInvestmentExperience === undefined) {
      setDefaultInvestmentExperience(experience)
    }
  }, [experience])

  const closeWithoutSaving = () => {
    setValue('experience', defaultInvestmentExperience)
    closeModal()
  }

  const closeWithSaving = () => {
    setDefaultInvestmentExperience(experience)
    closeModal()
  }

  return (
    <>
      <Field
        className="border-b py-sm"
        valueClassName="text-text-meta typo-primary-base-regular"
        value={t('edit_fields.investment_experience_title')}
        rightValue={t(`investment_experience.${experience}`)}
        testId={'editInvestmentExperience'}
        onEdit={openModal}
      />
      <ModalDrawer isOpen={isOpen} onClose={closeWithoutSaving} title={t('edit_fields.edit_investment_experience')}>
        <Controller
          name="experience"
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { ...restField } }) => (
            <RadioGroup
              {...restField}
              options={Object.values(EnrollmentInvestmentExperienceCategory).map((item) => ({
                value: item,
                label: t(`multi.investment-goals.investment_experience.${item}`),
              }))}
              name="experience"
              className="pb-md mt-md"
              testId="experience-radio"
            />
          )}
        />

        <Button size="small" onClick={closeWithSaving} className="w-full mt-lg" testId="primaryAction_button">
          {t('common.confirm')}
        </Button>
      </ModalDrawer>
    </>
  )
}
